import { useEffect } from "react";

import { useRootStore } from "store";
import { useIsMobile } from "hooks/use-is-mobile";
import { InboxReplyContextProvider } from "app/store/InboxReplyContext";
import InboxDesktopLayout from "./desktop";
import InboxMobileLayout from "./mobile";

import "./Inbox.scss";

export default function Inbox() {
  const isMobile = useIsMobile();

  const workingCustomerId = useRootStore((s) => s.global.workingCustomerId);
  const { fetchMyThreads, fetchAllThreads, fetchSentMessages } = useRootStore(
    (state) => state.inbox
  );
  const { fetchArchiveFolders } = useRootStore((s) => s.archive);

  useEffect(() => {
    if (!workingCustomerId) {
      return;
    }

    const loadInbox = async () => {
      try {
        await Promise.all([
          fetchMyThreads(workingCustomerId),
          fetchAllThreads(workingCustomerId),
          fetchSentMessages(workingCustomerId),
          fetchArchiveFolders(workingCustomerId)
        ]);
      } catch (error) {
        console.log("Failed to load inbox:", error);
      }
    };

    loadInbox();
  }, [
    workingCustomerId,
    fetchMyThreads,
    fetchAllThreads,
    fetchSentMessages,
    fetchArchiveFolders
  ]);

  return (
    <InboxReplyContextProvider>
      {isMobile ? <InboxMobileLayout /> : <InboxDesktopLayout />}
    </InboxReplyContextProvider>
  );
}
